import axios from "axios";

import Token from "../../utilities/jwt/Token.js";

export default class GestaoService extends Token {
  findAll() {
    return axios({
      method: "get",
      url: this.api_url + "gestao",
      withCredentials: true,
      headers: {
        Authorization: "Bearer " + this.token(),
      },
    }).then((res) => res.data);
  }

  create(gestao) {
    return axios({
      method: "post",
      url: this.api_url + "gestao",
      withCredentials: true,
      data: gestao,
      headers: {
        Authorization: "Bearer " + this.token(),
      },
    });
  }
  update(gestao) {
    return axios({
      method: 'put',
      url: this.api_url + 'gestao/' + gestao.id,
      withCredentials: true,
      data: gestao,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });

  }

  delete(id) {
    return axios({
      method: 'delete',
      url: this.api_url + 'gestao/' + id,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });

  }
}
